import { Suspense } from 'react'
import { useActionData, useNavigation, useParams, useRouteLoaderData, Link, Await, Form } from 'react-router-dom';
import AdminMatchesForm from '../../components/admin/AdminMatchesForm.jsx'
import AdminMatchesShow from '../../components/admin/AdminMatchesShow.jsx'
import { GetMatch, UpdateMatch } from "../../repo/MatchesRepo.js";
import { ListTeams } from "../../repo/TeamsRepo.js"
import { GetTournament } from "../../repo/TournamentsRepo.js"

export default function MatchEditPage() {
  const {tournamentId} = useParams()
  const response = useActionData()
  const matchRelations = useRouteLoaderData('admin-match-edit')
  const createNavigation = useNavigation()
  const isSubmitting = createNavigation.state === 'submitting'

  return (
    <section className="m-8">
      {response && response.status && response.status  ? (
        <AdminMatchesShow tournament={matchRelations.tournament} match={matchRelations.match} status="updated"/>
      ) : (
        <>
          <h1>Edit Match</h1>
          <div id="match-create-form" className={`w-full py-4 mb-4'`}>
            <Form method="PUT" className="space-y-4 md:space-y-6 mt-4">
              <Suspense fallback={<p>Carregando...</p>}>
                <Await resolve={matchRelations}>
                  {(loadedMatchRelations) => <AdminMatchesForm match={loadedMatchRelations.match} teams={loadedMatchRelations.teams.data} tournament={loadedMatchRelations.tournament} errors={(response && response.errors) ? response.errors : null } isSubmitting={isSubmitting}/>}
                </Await>
              </Suspense>
            </Form>
          </div>

          <div id="matches" className={`w-full pt-4 mt-4'`}>
            <Link className="hover:no-underline underline" to={`/cocofantoelefanto/tournaments/${tournamentId}/matches`}>Back to Matches</Link>
          </div>
        </>
      )}
    </section>
  )
}

export async function action({request}) {
  const data = await request.formData()

  const matchData = {
    team_a_id: data.get('team_a_id'),
    team_b_id: data.get('team_b_id'),
    tournament_id: data.get('tournament_id'),
    starts_at: data.get('starts_at'),
    group_name: data.get('group_name'),
    phase: data.get('phase'),
    third_party_label: data.get('third_party_label'),
    third_party_id: data.get('third_party_id'),
    is_demo: document.getElementById('is_demo').checked
  }

  return UpdateMatch(data.get('id'), matchData)
}

export async function loader({ params, request }) {
  return {
    match: await GetMatch(params.tournamentId, params.id),
    teams: await ListTeams(1, { skip_pagination: 1 }),
    tournament: await GetTournament(params.tournamentId)
  }
}
